import { IAMDashboardState } from '@/modules/amDashboard/store/state';
import { IRootState } from '@/store/state';
import { GetterTree } from 'vuex';
import SubmissionRequest from '@/models/SubmissionRequest';
import { PaginationMeta, AmFilter } from '../types';
import { PensionScheme } from '../../pensionScheme/types';
/**
 * --------------------------------------------------
 *	Dashboard Getters
 * --------------------------------------------------
 **/
export const AMDashboardGetters: IAMDashboardGetters = {
  submissionRequests: (state: IAMDashboardState): SubmissionRequest[] =>
    state.submissionRequests,
  amPaginationMeta: (state: IAMDashboardState): PaginationMeta =>
    state.amPaginationMeta,
  amFilters: (state: IAMDashboardState): AmFilter => state.amFilters,
  organizationClients: (state: IAMDashboardState): PensionScheme[] =>
    state.organizationClients,
  syncingSubmissions: (state: IAMDashboardState): Boolean =>
    state.syncingSubmissions
};

/**
 * --------------------------------------------------
 *	Dashboard Getters Interface
 * --------------------------------------------------
 **/
export interface IAMDashboardGetters
  extends GetterTree<IAMDashboardState, IRootState> {
  submissionRequests(state: IAMDashboardState): SubmissionRequest[];
  amPaginationMeta(state: IAMDashboardState): PaginationMeta;
  amFilters(state: IAMDashboardState): AmFilter;
  syncingSubmissions(state: IAMDashboardState): Boolean;
}
